import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Integrations from './Integrations';

const IntegrationsContainer: React.FC = () => (
  <Switch>
    <Route
      path={[
        '/dashboard/integrations/sar',
        '/dashboard/integrations/sdp',
        '/dashboard/integrations/meta',
        '/dashboard/integrations/salesforce',
        '/dashboard/integrations',
      ]}
      component={Integrations}
    />
    <Redirect from="/dashboard/sar" to="/dashboard/integrations/sar" />
  </Switch>
);

export default IntegrationsContainer;
